import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StatsScreen.css';

function getStats() {
  try {
    const raw = localStorage.getItem('focusup_stats');
    if (raw) return JSON.parse(raw);
  } catch {}
  return { totalSessions: 0, totalMinutes: 0, currentStreak: 0, bestStreak: 0, todayMinutes: 0, todaySessions: 0 };
}

export function StatsScreen() {
  const navigate = useNavigate();
  const stats = getStats();

  const statCards = [
    { value: stats.totalSessions, label: 'Sessions totales', icon: '🎯' },
    { value: `${Math.floor(stats.totalMinutes / 60)}h${String(stats.totalMinutes % 60).padStart(2, '0')}`, label: 'Temps focus total', icon: '⏱' },
    { value: stats.currentStreak, label: 'Streak actuel', icon: '🔥' },
    { value: stats.bestStreak, label: 'Meilleur streak', icon: '🏆' },
    { value: stats.todaySessions, label: "Aujourd'hui", icon: '📅' },
    { value: `${stats.todayMinutes}'`, label: "Focus aujourd'hui", icon: '⚡' },
  ];

  return (
    <div className="fu-stats">
      <div className="fu-stats-header">
        <button className="fu-back-btn" onClick={() => navigate('/')}>← Retour</button>
        <h1>Statistiques</h1>
      </div>

      {/* Level progress */}
      <div className="fu-level-card">
        <div className="fu-level-info">
          <span className="fu-level-badge">Niv. {Math.floor(stats.totalSessions / 5) + 1}</span>
          <span className="fu-level-xp">{stats.totalSessions * 50} XP</span>
        </div>
        <div className="fu-level-bar">
          <div className="fu-level-fill" style={{ width: `${(stats.totalSessions % 5) * 20}%` }} />
        </div>
        <span className="fu-level-hint">{5 - (stats.totalSessions % 5)} sessions avant le prochain niveau</span>
      </div>

      {/* Stats grid */}
      <div className="fu-stats-grid">
        {statCards.map((s, i) => (
          <div key={i} className="fu-stats-card">
            <span className="fu-stats-icon">{s.icon}</span>
            <span className="fu-stats-value">{s.value}</span>
            <span className="fu-stats-label">{s.label}</span>
          </div>
        ))}
      </div>

      {stats.totalSessions === 0 && (
        <div className="fu-stats-empty">
          <p>Aucune session pour l'instant.</p>
          <button className="fu-stats-cta" onClick={() => navigate('/focus')}>
            Commencer ma premiere session
          </button>
        </div>
      )}
    </div>
  );
}
